import { useAtomValue } from 'jotai';
import { createResourceAtom } from 'lib/atoms';
import { useMemo } from 'react';
import {
  GeologicIntervalQueryResponse,
  GeologicIntervalResponse,
} from 'types/api-responses';
import { formatResource } from 'utils/misc';
import { getUniqueBasinNames } from './util';
import searchAtomPair, { SearchParams } from 'atoms/search-atom';

interface GeologicIntervalSearchParams extends SearchParams {
  basinName: string | null;
}

export const useBasins = () => {
  const geoLogicalIntervalsAtom = useMemo(
    () => createResourceAtom<GeologicIntervalResponse>('/geologic_intervals'),
    []
  );
  const geoLogicalIntervalsData = useAtomValue(geoLogicalIntervalsAtom);
  const {
    data,
    error: basinsFetchError,
    loading: basinsFetchLoading,
  } = formatResource(geoLogicalIntervalsData);
  const basins = getUniqueBasinNames(
    data ?? { geologicIntervals: [], meta: { count: 0 } }
  );
  return {
    basins,
    basinsFetchError,
    basinsFetchLoading,
  };
};

export const useGeologicIntervals = (params: GeologicIntervalSearchParams) => {
  const { searchAtom: geologicalIntervalSearchAtom } = useMemo(
    () =>
      searchAtomPair<
        GeologicIntervalQueryResponse,
        GeologicIntervalSearchParams
      >('geologicIntervals', params),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const geologicalIntervalSearchResult = useAtomValue(
    geologicalIntervalSearchAtom
  );

  return useMemo(() => {
    return {
      data: geologicalIntervalSearchResult.data,
      error: geologicalIntervalSearchResult.error,
      loading: geologicalIntervalSearchResult.loading,
    };
  }, [geologicalIntervalSearchResult]);
};
